import { LeadListContactSummary } from "./LeadListContactSummary";

export class LeadListContactSummaryElement {
  readonly dialGroupId: string;
  readonly summary: LeadListContactSummary;

  constructor(deriveFrom?: Partial<LeadListContactSummaryElement>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    this.summary = new LeadListContactSummary(this.summary);
  }
}